import React from 'react';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './ActionCard.styles';
import { ACTION_OPTIONS } from '../../../../constants/triggers';

import Button from '../../../inputs/button/Button';

const ActionCard = props => {
  if (!props.action) {
    return;
  }
  return (
    <div className={css(styles.base)}>
      <div className={css(styles.text)}>
        <Translate
          value={ACTION_OPTIONS[props.action.type].text}
          customValue={props.action.value}
        />
      </div>
      {props.showActions && (
        <div className={css(styles.buttonContainer)}>
          <Button type="button" styles={styles.button} onClick={props.onEdit}>
            <Translate value="edit.edit" />
          </Button>
          <Button type="button" styles={styles.button} onClick={props.onDelete}>
            <Translate value="delete.delete" />
          </Button>
        </div>
      )}
    </div>
  );
};

export default ActionCard;



// WEBPACK FOOTER //
// ./src/components/data/triggerlist/actioncard/ActionCard.js